module.exports = __webpack_public_path__ + "static/img/feeds2.0fc6cd93.png";